import React from 'react';
import { ArrowsDiagonalOut16 } from '@honeybook/icons';
import HBIconButton from '../HBIconButton/HBIconButton';
import { IntractableBasicTestIdProps } from '../common/internal/test-id.types';

export interface HBSidePanelExpandButtonProps {
    onExpand: () => void;
    testId?: string;
    testIdName?: string;
}

export const HBSidePanelExpandButton: React.FC<
    HBSidePanelExpandButtonProps & IntractableBasicTestIdProps
> = ({ onExpand, testId, testIdName = 'expand' }) => {
    return (
        <HBIconButton
            buttonTheme="subtle-invisible"
            icon={ArrowsDiagonalOut16}
            label="expand"
            onClick={onExpand}
            size="xs"
            testId={testId}
            testIdName={testIdName}
        />
    );
};
